import { useTranslation } from 'react-i18next'
import omit from 'lodash-es/omit'

import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../constants/route'
import { useDateLocale, useTimeZone } from '../../../../hooks'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleBackButton,
  EntityProfileHeaderTitleWithStatus,
} from '../../../Entity'
import { MultipleViewTypeListActiveItemPreviewHeaderActions } from '../../../MultipleViewTypeList'
import { RentalPortalViewingDateTile } from '../../../RentalPortalViewing'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'
import { getViewingProfileTitle } from '../RentalPortalViewingProfile.utils'
import { RentalPortalViewingProfileHeaderFooter } from '../RentalPortalViewingProfileHeaderFooter'
import { RentalPortalViewingProfileHeaderInfoItems } from '../RentalPortalViewingProfileHeaderInfoItems'
import { RentalPortalViewingProfileHeaderStatusSelect } from '../RentalPortalViewingProfileHeaderStatusSelect'

import * as styles from './RentalPortalViewingProfileHeader.module.css'

function RentalPortalViewingProfileHeader({
  ToggleButton,
  isPreview,
  openFullPageActionsProps,
}) {
  const { t } = useTranslation()

  const { isInitiated, viewingData } = useViewingProfileContext()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <EntityProfileHeader
      Content={null}
      Footer={isPreview ? null : RentalPortalViewingProfileHeaderFooter}
      Header={EntityProfileHeaderTitleWithStatus}
      InfoItems={RentalPortalViewingProfileHeaderInfoItems}
      headerProps={{
        Actions: openFullPageActionsProps
          ? MultipleViewTypeListActiveItemPreviewHeaderActions
          : null,
        BackButton: isPreview ? null : EntityProfileHeaderTitleBackButton,
        EntityAvatar: RentalPortalViewingDateTile,
        Status: RentalPortalViewingProfileHeaderStatusSelect,
        ...(isPreview
          ? {
              ToggleButton,
              toggleButtonProps: {
                onClosePreview: openFullPageActionsProps?.onClosePreview,
              },
            }
          : null),
        actionsProps: openFullPageActionsProps
          ? {
              ...omit(openFullPageActionsProps, 'onClosePreview'),
              Actions: null,
            }
          : null,
        entityAvatarProps: {
          className: styles.avatar,
          isFreeSlot: !viewingData?.applicant,
          start: viewingData?.start,
        },
        sectionBackUrl: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}/${ROUTE_PATH_LIST_RENTAL_PORTAL.viewings}`,
        statusProps: { className: styles.statusSelect },
        text: getViewingProfileTitle({ locale, t, timezone, viewingData }),
        textProps: { editable: false },
      }}
      infoItemsProps={{ isPreview }}
      isLoading={!isInitiated}
    />
  )
}

export default RentalPortalViewingProfileHeader
